import { useMemo } from "react";

import { batch } from "../helpers";

export default function useBatch(db) {
	return useMemo(() => batch.bind(null, db), [db]);
}
